import React from "react";
import { Tooltip } from "antd";
import { motion } from "framer-motion";
import { SettingOutlined } from "@ant-design/icons";
import redirectUrl from "../../../auth/redirectToApp";

const SettingsLauncher: React.FC = () => {
  const target = process.env.REACT_APP_MASTERS_URL || "";

  const handleClick = () => {
    if (!target) return;
    const loginMethod = localStorage.getItem("loginMethod");
    if (loginMethod === "azure") {
      redirectUrl(target);
    } else {
      window.open(target, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Tooltip title="Settings (Masters)" placement="bottom">
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <SettingOutlined style={{ fontSize: 18 }} />
      </motion.div>
    </Tooltip>
  );
};

export default SettingsLauncher;
